import script from "./TreeSelectorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreeSelectorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TreeSelectorDialog.vue?vue&type=style&index=0&id=5f7156fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7156fb"]])

export default __exports__